export default "__VITE_ASSET__7c7b4ddf__"